import React, {Component} from 'react'
import {Actions} from 'jumpstate'
import {connect} from 'react-redux'
import {Grid, Col, Row} from 'react-bootstrap'
import { Helmet } from 'react-helmet'
import showToastr from '../../utils/showToastr'
import Clipboard from 'clipboard'
import HorseDetails from '../HorseInfo/HorseDetails'
import AdDetails from './AdDetails'
import HorseLoading from '../Common/HorseLoading/HorseLoading'
import NotFound from '../Common/NotFound/NotFound'

import './Layout/SingleAdScreen.css'

const horseAvatar = `${window.location.protocol}//${window.location.host}/horse.jpg`

class SingleAdScreen extends Component {
  constructor (props) {
    super(props)
    this.state = {
      info: {},
      isLoading: true,
      showNotFound: false,
      link: '',
      supportsClipboard: window.__BROWSER_ENV__,
      clipboard: window.__BROWSER_ENV__ ? new Clipboard('.copy-button') : {}
    }
    this.prepareClipboard()
  }

  componentWillMount () {
    this.setState({
      isLoading: false,
      showNotFound: false,
      info: this.props.ad,
      link: `${window.location.origin}/ad/${this.props.params.id}`
    })
    if (window.__BROWSER_ENV__) {
      this.setState({isLoading: true, showNotFound: false})
      Actions.adInfo(this.props.params.id).catch((e) => {
        if (e.response && e.response.status === 404) {
          this.setState({showNotFound: true, isLoading: false})
        }
      })
    }
  }

  componentWillReceiveProps (nextProps) {
    if (nextProps.ad) {
      if (nextProps.ad.id !== nextProps.params.id) {
        return this.setState({isLoading: true}, () => Actions.adInfo(nextProps.params.id).catch((e) => {
          if (e.response && e.response.status === 404) {
            this.setState({showNotFound: true, isLoading: false})
          }
        }))
      }
      return this.setState({info: nextProps.ad, link: `${window.location.origin}/ad/${nextProps.ad.id}`, isLoading: false, showNotFound: false})
    }
    this.setState({isLoading: true})

    Actions.adInfo(nextProps.params.id).then(data => {
      this.setState({info: data, link: `${window.location.origin}/ad/${data.id}`, isLoading: false, showNotFound: false})
    }).catch((error) => {
      if (error.response.status === 404) {
        this.setState({showNotFound: true, isLoading: false})
      }
    })
  }

  prepareClipboard () {
    if (!this.state.supportsClipboard) { return undefined }
    this.state.clipboard.on('success', () => {
      showToastr('info', 'آگهی', `لینک آگهی به حافظه منتقل شد`)
    })
  }

  render () {
    const { info, isLoading, showNotFound, link } = this.state

    return (
      <div className="HorseInfo AdInfo">
        {isLoading ? <HorseLoading />
          : showNotFound ? <NotFound route={this.props.location} />
            : <Grid>
              <Helmet>
                <title>Iaho</title>
                <meta name="description" content={SingleAdScreen.makeAdDescription(info)} />
                <meta property="og:title" content={AdDetails.translateAdType(info.type) + ' ' + info.horse.name} />
                <meta property="og:locale" content="fa_IR" />
                <meta property="og:type" content="website" />
                <meta property="og:site_name" content="ایاهو | موتور جستجوی اسب اصیل" />
                <meta property="og:description" content={SingleAdScreen.makeAdDescription(info)} />
                <meta property="og:image" content={`${info.horse.avatar ? info.horse.avatar : horseAvatar}`} />
                <meta property="og:url" content="https://iaho.ir/" />
                <meta property="twitter:description" content={SingleAdScreen.makeAdDescription(info)} />
                <meta property="twitter:card" content={AdDetails.translateAdType(info.type) + ' ' + info.horse.name} />
                <meta name="twitter:image:alt" content={AdDetails.translateAdType(info.type) + ' ' + info.horse.name} />
              </Helmet>
              <Row className="Wraper">
                <Col lg={5} lgOffset={1} md={6} mdOffset={0} sm={10} smOffset={1} xs={12} xsOffset={0}>
                  <AdDetails info={info} auth={this.props.auth} link={link} />
                </Col>
                <Col lg={5} lgOffset={0} md={6} mdOffset={0} sm={10} smOffset={1} xs={12} xsOffset={0} className="HorseBoxInfo">
                  <HorseDetails info={info.horse} />
                </Col>
              </Row>
            </Grid>
        }
      </div>
    )
  }
}

SingleAdScreen.makeAdDescription = (data) => {
  const dam = data.horse.dam.name ? data.horse.dam.name : 'نامشخص'
  const sire = data.horse.sire.name ? data.horse.sire.name : 'نامشخص'
  const price = data.price > 0 ? parseInt(data.price, 10).toLocaleString() : 'توافقی'
  return 'پدر: ' + sire + ' مادر:' + dam + ' | ' + ' مالک:' + data.horse.owners[0].name +  ' | ' + ' قیمت:' + price
}

SingleAdScreen.prepareHorseImage = (data) => (data.avatar ? data.avatar : 'http://iaho.ir/horse.jpg')

SingleAdScreen.fetchData = ({params}) => {
  return Actions.adInfo(params.id)
}

function mapStateToProps (state) {
  return {
    ad: state.ad.details,
    auth: state.auth
  }
}

export default connect(mapStateToProps)(SingleAdScreen)



// WEBPACK FOOTER //
// ./src/components/Ad/SingleAdScreen.js